import "./styles.sass"
import assets from '../../assets'
import { ANALISYS } from '../../utils/constant'

export const AiAnalysis = () => {

    const renderAnalysis = (item) =>{
        const {title,description,success} = item || {}
        return(
             <section className="analysing_wrapper">
             <img src={success ? assets.ic_success_tick : assets.ic_gray_tick} alt="ic_success_tick"/>
            <section className="">
               <h4>{title}</h4>
               <h5 className="desc_text">{description}</h5>
           </section>
             </section>
        )
    }
  return (
    <section className="main_analysis_wrapper">
         <img src={assets.ic_magic_logo} alt="ic_magic_logo"/>
        <section>
             <h4 className="header_txt">Generating Your Content</h4>
             <h5 className="header_desc">Our AI is creating personalized learning material for your selected topics</h5>
        </section>
           <section className="bar_wrapper">
              <section className="blue_bar_wrapper"></section>
           </section>
           <section className="analysis_content_wrapper">{ANALISYS.map(renderAnalysis)}</section>

        <section className="footer_desc_wrapper">
            <img src={assets.ic_lightbulb} alt="ic_lightbulb"/>
            <section className="info_desc">
                <h4>Did you know?</h4>
                <p>Our AI analyzes thousands of curriculum resources to create the most relevant content for students.</p>
            </section>
        </section>
    </section>
  )
}

